module.exports = __webpack_public_path__ + "static/media/mazaZolePlayed_1000000.9bbf5a45.png";